<template>
  <div class="analytics-report-ontime-late">
    <div class="level">
      <h3 class="level-left">
        Count of correct and revised reports
      </h3>
      <div class="level-right ontime-late-calender-picker">
        <label>From </label>
        <b-datepicker
          class="analytics-date-picker actual-submission-start-date"
          v-model="starting_date"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="selectByDateRange"
        >
        </b-datepicker>

        <label>To </label>
        <b-datepicker
          class="analytics-date-picker"
          v-model="end_date"
          position="is-bottom-left"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="selectByDateRange"
        >
        </b-datepicker>
      </div>
    </div>

    <apexchart
      v-if="series.length > 0"
      type="pie"
      height="450"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import analyticsService from "@/services/AnalyticsService";
import utitlityMixin from "@/mixins/UtilityMixin";
import AccountCustomerService from "../../services/AccountCustomerService";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],

  data() {
    return {
      switchCustomerId: null,
      starting_date: this.sixMonthsBefore(),
      end_date: this.currentDate(),
      year: this.currentYear(),
      analyticsService: new analyticsService(),
      accountCustomerService: new AccountCustomerService(),
      series: [0, 0, 0],
      chartOptions: {}
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchReportsCounts(this.year);
  },
  methods: {
    selectByDateRange() {
      this.year = null;
      this.fetchReportsCounts(this.year);
    },
    fetchReportsCounts(year) {
      const start_date = this.dateFormatterNew(this.starting_date);
      const end_date = this.dateFormatterNew(this.end_date);
      if (start_date != null && end_date != null && start_date >= end_date) {
        alert("end date should be greater than start date");
        return false;
      }
      this.analyticsService
        .getReportTrackerCount(
          year,
          this.switchCustomerId,
          this.dateFormatterNew(this.starting_date),
          this.dateFormatterNew(this.end_date)
        )
        .subscribe(response => {
          this.series = response;
          this.chartOptions = {
            chart: {
              type: "pie",
              height: 450,
              stacked: true,
              toolbar: {
                show: true
              }
            },
            colors: ["#48C774", "#2BABE2", "#EE893D"],
            labels: [
              "Correct",
              "Revision due to incorrect data from customer",
              "Revision due to Reporting Resp's incorrect calculation"
            ]
          };
        });
    }
  }
};
</script>
